<template>
  <div
    v-loading.fullscreen.lock="loading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-form
      size="small"
      ref="form"
      :model="formData"
      label-width="118px"
      :rules="rules"
      inline-message
      status-icon
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="客户名称">
            <el-input v-model="formData.custName" disabled> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="ERP/WMS单号">
            <el-input v-model="formData.bizBillNo" disabled> </el-input
          ></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单编号">
            <el-input v-model="formData.dispatchOrderNo" disabled> </el-input
          ></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运单号">
            <el-input v-model="formData.waybillNo" disabled> </el-input
          ></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回单类型" prop="podType">
            <dict-select
              v-model="formData.podType"
              :body="podTypeDictParams"
              filterable
              clearable
              default
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回单返回时间" prop="podBackTime">
            <el-date-picker
              clearable
              v-model="formData.podBackTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
              placeholder="请选择回单返回时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回单周期(小时)" prop="podHours">
            <el-input-number
              clearable
              v-model="formData.podHours"
              controls-position="right"
              :max="2400"
              :min="0"
              :step-strictly="true"
              :step="1"
              style="width:100%"
              placeholder="请输入回单周期"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回单份数" prop="podQty">
            <el-input-number
              clearable
              v-model="formData.podQty"
              controls-position="right"
              :max="999"
              :min="1"
              :step-strictly="true"
              :step="1"
              style="width:100%"
              placeholder="请输入回单份数"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="签收人">
            <el-input
              clearable
              v-model="formData.signPerson"
              placeholder="请输入签收人"
              maxlength="50"
              show-word-limit
            >
            </el-input
          ></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="签收数量" prop="signQty">
            <el-input-number
              clearable
              v-model="formData.signQty"
              controls-position="right"
              :max="999"
              :min="1"
              :step-strictly="true"
              :step="1"
              style="width:100%"
              placeholder="请输入签收数量"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              clearable
              v-model="formData.podRemarks"
              type="textarea"
              :rows="7"
              placeholder="请输入回单备注"
              maxlength="200"
              show-word-limit
            >
            </el-input
          ></el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="添加图片" required>
            <el-upload
              class="upload"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="onUploadPreview"
              :on-change="onUploadChange"
              :on-remove="onUploadRemove"
              :file-list="fileList"
              accept="image/png,image/jpeg"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-show="false" class="images" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in fileList"
        :src="item.url || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否确认提交</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不提交</el-button>
        <el-button @click="save()" type="primary" size="small">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    order: { type: Object, default: () => {} },
  },
  data() {
    return {
      loading: false,
      formData: {
        podType: '',
        podBackTime: '',
        podHours: 0,
        podQty: 0,
        signPerson: '',
        signQty: 0,
        podRemarks: '',
      },
      podTypeDictParams: { type: 'podType' },
      backDialogVisible: false,
      listImage: [],
      fileList: [],
      successFileList: [],
      rules: {
        podHours: [
          {
            required: true,
            message: '请输入回单周期',
            trigger: ['blur', 'change'],
          },
        ],
        podQty: [
          {
            required: true,
            message: '请输入回单份数',
            trigger: ['blur', 'change'],
          },
        ],
        signQty: [
          {
            required: true,
            message: '请输入签收数量',
            trigger: ['blur', 'change'],
          },
        ],
        podBackTime: [
          {
            required: true,
            message: '请选择运单返回时间',
            trigger: 'change',
          },
        ],
        podType: [
          {
            required: true,
            message: '请选择回单类型',
            trigger: 'change',
          },
        ],
        podStatus: [
          {
            required: true,
            message: '请选择回单状态',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    order: {
      handler(order) {
        this.formData.custName = order.custName
        this.formData.bizBillNo = order.bizBillNo
        this.formData.dispatchOrderNo = order.dispatchOrderNo
        this.formData.waybillNo = order.waybillNo
        this.formData.waybillCode = order.waybillCode
        this.formData.dispatchOrderCode = order.dispatchOrderCode
        this.formData.orderCode = order.orderCode
        this.formData.orderNo = order.orderNo
        this.formData.waybillDetailCode = order.waybillDetailCode
        if (order.bizStatus === '4' || order.bizStatus === '6') {
          this.loadData(order.waybillDetailCode)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onUploadChange(file, fileList) {
      this.listImage = []
      this.successFileList = []
      fileList.forEach((i) => {
        if (i.status === 'success') {
          this.successFileList.push({
            imageCode: i.name,
            imageUrl: i.url.substr(i.url.indexOf('/oss')),
          })
        }
      })

      this.fileList = fileList
    },
    onUploadRemove(file, fileList) {
      this.listImage = []
      this.successFileList = []
      fileList.forEach((i) => {
        if (i.status === 'success') {
          this.successFileList.push({
            imageCode: i.name,
            imageUrl: i.url.substr(i.url.indexOf('/oss')),
          })
        }
      })
      this.fileList = fileList
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      this.loading = true

      try {
        this.listImage = await this.uploadImages()
      } catch (err) {
        this.loading = false
        this.$message({
          showClose: true,
          message: '图片上传错误，请检查后重试',
          type: 'error',
        })
        return
      }
      this.formData.podStatus = '1'
      const listImage = this.listImage.concat(this.successFileList)
      if (!listImage || listImage.length == 0) {
        this.$message({
          showClose: true,
          message: '上传图片不能为空',
          type: 'error',
        })
        this.loading = false
        return
      }

      this.$api
        .carrierWaybillUploadPodApi({
          ...this.formData,
          listImage: listImage,
        })
        .then((res) => {
          this.loading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loading = false
        })
    },
    uploadImages() {
      if (!this.fileList || !this.fileList.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.fileList.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          imageCode: res.body.id,
          imageUrl: res.body.url,
        }))
      })
      return Promise.all(uploadTask)
    },
    // uploadFile(params) {
    //   if (!params.raw) return
    //   return this.$api
    //     .SYS_UPLOAD(params.raw)
    //     .then((res) => {
    //       let img = {
    //         imageCode: res.body.id,
    //         imageUrl: res.body.url,
    //       }
    //       this.listImage.push(img)
    //     })
    //     .catch((e) => {
    //       this.loading = false
    //       console.log('POD回单上传失败 ==> ', e)
    //     })
    // },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = true
      this.$emit('close')
    },
    onUploadPreview(file) {
      // 获取图片下标
      const index = this.fileList.findIndex((i) => {
        return i.uid == file.uid
      })
      // 点击大图显示图片预览组件
      if (this.fileList.length > 0) {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.view(index)
        viewer.show()
      }
    },
    loadData(waybillDetailCode) {
      this.$api
        .carrierWaybillSelectPodApi({ waybillDetailCode })
        .then((res) => {
          const { body } = res
          this.listImage = body.podImgList
          this.fileList = body.podImgList.map((i) => {
            return {
              name: i.imageCode,
              url: this.$osscdn(i.imageUrl),
            }
          })

          this.formData.podRemarks = body.podRemarks
          this.formData.signPerson = body.signPerson
          this.formData.podType = body.podType
          this.formData.podBackTime = body.podBackTime
          this.formData.podHours = body.podHours
          this.formData.podStatus = body.podStatus
          this.formData.signQty = body.signQty
          this.formData.podQty = body.podQty
          this.formData.wayBillPodCode = body.wayBillPodCode
        })
    },
  },
}
</script>
<style scoped>
.upload >>> .el-upload--picture-card {
  width: 140px;
  height: 140px;
}
.upload >>> .el-upload {
  width: 140px;
  height: 140px;
  line-height: 140px;
}
.upload >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 140px;
  height: 140px;
}
.upload >>> .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 140px;
  height: 140px;
  line-height: 140px;
}
.upload >>> .avatar {
  width: 140px;
  line-height: 140px;
}
</style>
